import { httpClient } from "./httpClient";

const getDashboardContract = (query) => {
  return httpClient.get("/dashboard/contract", { params: query });
};

export default {
    getDashboardContract,
};
